import { render, staticRenderFns } from "./AttributeLotModal.vue?vue&type=template&id=1c25c624"
import script from "./AttributeLotModal.vue?vue&type=script&lang=js"
export * from "./AttributeLotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports